import styles from './Hyperlink.module.scss';

type Props = {
    href: string,
    text: string
}

export default function Hyperlink({href, text}: Props) {
    return <a className={styles.hyperlink} href={href}>{text}</a>
}